import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { ReferralModel, ReferralService} from "@bt/core";
import { NotifierService } from "angular-notifier";
import {faCopy} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent extends BaseComponent implements OnInit {

  faCopy = faCopy;
  notifier: any;
  public referralView: boolean = false;

  referral: ReferralModel;

  constructor(
    private referralService: ReferralService,
    notifierService: NotifierService,
  ) {
    super();
    this.notifier = notifierService;
   }

  ngOnInit() {
    this.referral = new ReferralModel();
    this.GetRefLink();
  }

  GetRefLink(){
    this.setLoading(true);
    this.referralService.GetRefLink()
    .then((resp) => {
      this.referral = resp.data;
      this.referral.inviter == "" ? this.referralView = false : this.referralView = true;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении реферальной ссылки");
      this.setLoading(false);
    });
  }

  CopyLink(refLink: string){

    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = refLink;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.notifier.notify('success', "Успешно скопировано");
  }

}



// WEBPACK FOOTER //
// ./src/app/referral/referral.component.ts